import { Container, Row } from "react-bootstrap";
import { Outlet, useSearchParams } from "react-router-dom";
import Header from "../Header";
import HelpNav from "./HelpNav";
import { contextArticleFor } from "./contextMap";
import "./help.scss";

export default function HelpLayout() {
  const [searchParams] = useSearchParams();
  const from = searchParams.get("from");

  // Find the best matching help article for the source page
  const contextArticle = from ? contextArticleFor(from) : undefined;

  return (
    <>
      <Header />
      <Container fluid className="help-container">
        <Row className="flex-nowrap">
          <HelpNav contextArticle={contextArticle} />
          <main className="help-content col py-3 ps-4">
            <Outlet />
          </main>
        </Row>
      </Container>
    </>
  );
}
